// Presentational error state shown when slip parsing fails. heading/body override the generic
// copy for a refusal the server explains (#1652: a screenshot from another league).
function ImportErrorState({debugInfo, onRetry, heading = "Couldn't read this slip", body = "Try a clearer screenshot with the full slip visible. Make sure the odds and bet details are readable."}) {
  return (
    <div style={{textAlign:"center",padding:"32px 20px"}}>
      <div style={{fontSize:36,marginBottom:12}}>⚠️</div>
      <div style={{fontSize:14,fontWeight:700,color:"#f87171",marginBottom:8}}>{heading}</div>
      <div style={{fontSize:12,color:"#334155",marginBottom:20,lineHeight:1.6}}>{body}</div>
      {debugInfo && (
        <div style={{background:"#0a1628",borderRadius:8,padding:"10px 12px",marginBottom:16,border:"1px solid #1e3a5f",textAlign:"left"}}>
          <div style={{fontSize:9,color:"#4f46e5",fontWeight:800,letterSpacing:"1px",marginBottom:6}}>DEBUG INFO</div>
          <div style={{fontSize:10,color:"#64748b",wordBreak:"break-all",lineHeight:1.5}}>{debugInfo}</div>
        </div>
      )}
      <button onClick={onRetry} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"12px 24px",color:"#e2e8f0",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
        Try Again
      </button>
    </div>
  );
}

export default ImportErrorState;
